import { z } from 'zod';

const pauseOptionSchema = z.looseObject({
	months: z.number(),
	startsAt: z.string(),
	resumesAt: z.string(),
});

const retentionSchema = z.looseObject({
	canCancel: z.boolean(),
	canRevertCancel: z.boolean(),
	canPause: z.boolean(),
	pauseBlockedReason: z.string().nullable(),
	canResume: z.boolean(),
	pauseOptions: z.array(pauseOptionSchema),
});

export const subscriptionSchema = z
	.looseObject({
		id: z.string(),
		subscriptionStatus: z.string(),
		priceId: z.string(),
		stripePrices: z.looseObject({
			unitAmount: z.number(),
			products: z.looseObject({
				name: z.string(),
				shortDescription: z.string().nullable(),
			}),
		}),
		cancelAtPeriodEnd: z.boolean(),
		currentPeriodEnd: z.string().nullable(),
		priceInterval: z.string().nullable(),
		pause: z
			.looseObject({
				startsAt: z.string(),
				resumesAt: z.string().nullable(),
			})
			.nullable(),
		// Optional so a backend deployed without it degrades to "no retention offers".
		retention: retentionSchema.optional(),
	})
	.nullable();

export const productSchema = z.looseObject({
	id: z.string(),
	stripeProductId: z.string(),
	name: z.string(),
	active: z.boolean(),
});

export const productsSchema = z.array(productSchema);
